import { ThemeProvider } from "@mui/material/styles";
import { ConfigProvider } from "context/ConfigContext";
import CybridBankAdditionPage from "pages/cybridBankAdd/cybrid-bank-add";
import { useSearchParams } from "react-router-dom";
import themeOptions from "styles/theme";

const CybridBankAddition: React.FC = () => {
    const [searchParams] = useSearchParams();

    const signature = searchParams.get("signature") || searchParams.get("secret")
    const timestamp = searchParams.get("timestamp")
    const userId = searchParams.get("user_id")
    const clientId = searchParams.get("api_key") || searchParams.get("client_id")
    const mode = "DEV"
    const hv_token = searchParams.get("hv_token")


    let init

    if (signature && timestamp && userId && clientId && mode) {
        init = async () => {
            return { signature, timestamp, userId, clientId, mode, hv_token };
        };
    }
    const version = searchParams.get("version") ?? "0"

    window.sessionStorage.setItem("client_version", version);

    return (
        <>
            <ConfigProvider>
                <ThemeProvider theme={themeOptions}>
                    <CybridBankAdditionPage
                        token={searchParams.get("kyc_token")}
                        redirectUrl={searchParams.get("redirect_url")}
                    />
                </ThemeProvider>
            </ConfigProvider>
        </>

    );
};

export default CybridBankAddition;
